









'use strict';

var FlattenStyle={
current:function current(style){return style;},
inject:function inject(flatten){
FlattenStyle.current=flatten;
}};


module.exports=FlattenStyle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/animated/lib/injectable/FlattenStyle.js
// module id = 160
// module chunks = 0